import Flickity from 'flickity-imagesloaded';

const {registerModule} = window;

class Carousel {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  initialize() {
    this.bindUI();
    this.initCarousel();

    setTimeout(() => {
      this.flkty.resize();
    }, 600);

    if (this.ui.$items.length > 0) {
      this.bindEvents();
    }
  }

  unmount() {
    this.flkty.destroy();
  }

  bindUI() {
    this.ui = {};
    this.ui.$carousel = this.element.querySelector('[data-ref="carousel-wrapper"]');
    this.ui.$items = this.ui.$carousel.querySelectorAll('[data-ref="carousel-item"]');
    this.ui.$arrows = [...this.element.querySelectorAll('[data-ref="carousel-arrow"]')];
    this.ui.$arrowPrev = this.element.querySelector('[data-direction="prev"]');
    this.ui.$arrowNext = this.element.querySelector('[data-direction="next"]');
    this.ui.position = this.element.getAttribute('data-position');
    this.isDraggable = (this.ui.position === 'Left' && this.ui.$items.length > 5) || (this.ui.position === 'Center' && this.ui.$items.length > 3);
    const activeElement = this.element.querySelector('.resourceCard--active');
    if (activeElement) {
      this.ui.$activeElementIndex = Array.from(activeElement.parentElement.children).indexOf(activeElement);
    }
    this.isMobile = window.matchMedia('(max-width: 1024px)').matches;
  }

  initCarousel() {
    this.flkty = new Flickity(this.ui.$carousel, {
      prevNextButtons: false,
      pageDots: false,
      cellAlign: this.isMobile || (this.ui.position === 'Left') ? 'left' : 'center',
      draggable: this.isMobile ? true : this.isDraggable ? true : false,
      initialIndex: this.ui.$activeElementIndex ? this.ui.$activeElementIndex : 0,
    });

    this.flkty.on('dragStart', () => this.flkty.slider.style.pointerEvents = 'none');
    this.flkty.on('dragEnd', () => this.flkty.slider.style.pointerEvents = 'auto');
  }

  bindEvents() {
    this.ui.$arrows.forEach(($arrow) => {
      $arrow.addEventListener('click', this.toggle.bind(this));
    });

    this.flkty.on('select', this.onSelect.bind(this));
  }

  toggle(e) {
    const target = e.currentTarget;
    if (!target.matches('[data-ref="carousel-arrow"]')) return;

    const direction = target.getAttribute('data-direction');

    if (direction === 'next') {
      this.flkty.next(false, false);
    } else {
      this.flkty.previous(false, false);
    }
  }

  onSelect() {
    /* eslint-disable  no-negated-condition */
    if (!this.flkty.cells[this.flkty.selectedIndex - 1]) {
      this.ui.$arrowPrev?.setAttribute('disabled', 'disabled');
      this.ui.$arrowNext?.removeAttribute('disabled');
    } else if (!this.flkty.cells[this.flkty.selectedIndex + 1]) {
      this.ui.$arrowNext.setAttribute('disabled', 'disabled');
      this.ui.$arrowPrev.removeAttribute('disabled');
    } else {
      this.ui.$arrowPrev.removeAttribute('disabled');
      this.ui.$arrowNext.removeAttribute('disabled');
    }
  }
}

registerModule('Carousel', Carousel);


class CarouselMedia {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  initialize() {
    this.bindUI();
    this.initCarousel();
    this.resize();

    if (this.ui.$items.length > 0) {
      this.bindEvents();
    }
  }

  unmount() {
    this.flkty.destroy();
  }

  bindUI() {
    this.ui = {};
    this.ui.$carousel = this.element.querySelector('[data-ref="carousel-wrapper"]');
    this.ui.$items = this.ui.$carousel.querySelectorAll('[data-ref="carousel-item"]');
    this.ui.$arrows = [...this.element.querySelectorAll('[data-ref="carousel-arrow"]')];
    this.ui.$arrowPrev = this.element.querySelector('[data-direction="prev"]');
    this.ui.$arrowNext = this.element.querySelector('[data-direction="next"]');
    this.isMobile = window.matchMedia('(max-width: 1024px)').matches;
  }

  initCarousel() {
    this.flkty = new Flickity(this.ui.$carousel, {
      prevNextButtons: false,
      pageDots: false,
      cellAlign: 'left',
      draggable: this.isMobile ? true : false,
    });
  }

  bindEvents() {
    this.ui.$arrows.forEach(($arrow) => {
      $arrow.addEventListener('click', this.toggle.bind(this));
    });

    this.flkty.on('select', this.onSelect.bind(this));
    window.addEventListener('resize', this.resize.bind(this));
  }

  toggle(e) {
    const target = e.currentTarget;
    if (!target.matches('[data-ref="carousel-arrow"]')) return;

    const direction = target.getAttribute('data-direction');

    if (direction === 'next') {
      this.flkty.next(false, false);
    } else {
      this.flkty.previous(false, false);
    }
  }

  resize() {
    if (this.ui.$carousel.classList.contains('flickity-resize')) {
      this.ui.$carousel.classList.remove('flickity-resize');
    }
    setTimeout(() => {
      this.flkty.resize();
      this.ui.$carousel.classList.add('flickity-resize');
    }, 600);
  }

  onSelect() {
    /* eslint-disable  no-negated-condition */
    if (!this.flkty.cells[this.flkty.selectedIndex - 1]) {
      this.ui.$arrowPrev.setAttribute('disabled', 'disabled');
      this.ui.$arrowNext.removeAttribute('disabled');
    } else if (!this.flkty.cells[this.flkty.selectedIndex + 1]) {
      this.ui.$arrowNext.setAttribute('disabled', 'disabled');
      this.ui.$arrowPrev.removeAttribute('disabled');
    } else {
      this.ui.$arrowPrev.removeAttribute('disabled');
      this.ui.$arrowNext.removeAttribute('disabled');
    }
  }
}

registerModule('CarouselMedia', CarouselMedia);
